module.exports = __webpack_public_path__ + "assets/img/order_1.748aaf03.svg";